import { forwardRef } from 'react';
import { IconProps } from '../iconTypes';
const SVGIcon = forwardRef<SVGSVGElement, IconProps>(({
  size = 14,
  ...props
}, svgRef) => {
  if (size) {
    props.width = size;
    props.height = size;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" viewBox="0 0 256 512" ref={svgRef} {...props}><path d="M48 144a48 48 0 100-96 48 48 0 100 96zm0 160a48 48 0 100-96 48 48 0 100 96zm48 112a48 48 0 10-96 0 48 48 0 1096 0zm112-272a48 48 0 100-96 48 48 0 100 96zm48 112a48 48 0 10-96 0 48 48 0 1096 0zm-48 208a48 48 0 100-96 48 48 0 100 96z" /></svg>;
});
SVGIcon.displayName = "SolidGripDotsVertical";
export default SVGIcon;